var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ActionSheet, ActionSheetHeader } from '@progress/kendo-react-layout';
import { xIcon } from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { MOBILE_SMALL_DEVISE } from '../common/constants';
/** @hidden */
export var AdaptiveMode = function (props) {
    var defaultProps = {
        navigatable: props.navigatable || false,
        navigatableElements: props.navigatableElements || [],
        expand: props.expand,
        animation: props.animation === false ? false : true,
        onClose: props.onClose,
        animationStyles: props.windowWidth && props.windowWidth <= MOBILE_SMALL_DEVISE ? { top: 0, width: '100%', height: '100%' } : undefined,
        className: props.windowWidth && props.windowWidth <= MOBILE_SMALL_DEVISE
            ? 'k-adaptive-actionsheet k-actionsheet-fullscreen'
            : 'k-adaptive-actionsheet k-actionsheet-bottom'
    };
    return (React.createElement(ActionSheet, __assign({}, defaultProps),
        React.createElement(ActionSheetHeader, { className: 'k-text-center' },
            React.createElement("div", { className: "k-actionsheet-titlebar-group k-hbox" },
                React.createElement("div", { className: "k-actionsheet-title" },
                    React.createElement("div", null, props.adaptiveTitle)),
                React.createElement("div", { className: "k-actionsheet-actions" },
                    React.createElement(Button, { tabIndex: 0, "aria-label": "Cancel", "aria-disabled": "false", type: "button", fillMode: "flat", icon: 'x', svgIcon: xIcon, onClick: props.onClose })))),
        props.children));
};
